"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryParamsString = exports.requestBuilder = void 0;
const requestBuilder = (sysLevel, bodyParams, includeCredentials = false, headers) => {
    const PUBLIC_URLS = {
        eng: 'https://fmf-mr.esfe.c1.vanguard.com',
        sat: 'https://fmf-mr.esft.c1.vanguard.com',
        prd: 'https://fmf-mr.esfp.c1.vanguard.com',
    };
    const queryString = (0, exports.getQueryParamsString)(headers);
    const result = {
        url: PUBLIC_URLS[sysLevel] + '/log' + queryString,
        request: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(bodyParams),
        },
    };
    _addHeaderIfTruthy([
        {
            key: 'transactionId',
            value: headers.transactionId,
        },
        {
            key: 'serviceName',
            value: headers.serviceName,
        },
        {
            key: 'poid',
            value: headers.poid,
        },
        {
            key: 'ip',
            value: headers.ip,
        },
        {
            key: 'flowType',
            value: headers.flowType,
        },
        {
            key: 'poid',
            value: headers.poid,
        },
        {
            key: 'subFlowType',
            value: headers.subFlowType,
        },
        {
            key: 'userType',
            value: headers.userType,
        },
        {
            key: 'vgClientPoid',
            value: headers.vgClientPoid,
        },
        {
            key: 'vgCallChain',
            value: headers.vgCallChain,
        },
        {
            key: 'vgReferer',
            value: headers.vgReferer,
        },
    ], result.request);
    if (includeCredentials)
        result.request.credentials = 'include';
    return result;
};
exports.requestBuilder = requestBuilder;
function _addHeaderIfTruthy(headers, request) {
    headers.forEach((header) => {
        const value = header.value;
        const key = header.key;
        if (value && request.headers) {
            request.headers[key] = value;
        }
    });
}
const getQueryParamsString = (headers) => {
    const queryParams = {
        transactionId: headers.transactionId || '',
        flowType: headers.flowType || '',
        poid: headers.poid || '',
        vgClientPoid: headers.vgClientPoid || '',
        vgCallChain: headers.vgCallChain || '',
        vgReferer: headers.vgReferer || '',
    };
    const queryString = new URLSearchParams(queryParams).toString();
    return `?${queryString}`;
};
exports.getQueryParamsString = getQueryParamsString;
